import { ITranscriptionWord } from '../interfaces';

const MILLISECONDS_IN_A_SECOND = 1000;
const NANOSECONDS_IN_A_SECOND = 1000000000;

const normalizeTimestampNumber = (value: string | number | null | undefined): number => {
    if (typeof value === 'number') {
        return Number.isFinite(value) ? value : 0;
    }

    if (typeof value === 'string') {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : 0;
    }

    return 0;
};

const getTranscriptionWordTimestampMs = ({
    word,
    edge,
}: {
    word: ITranscriptionWord,
    edge: 'start' | 'end',
}): number => {
    const timestamp = edge === 'start'
        ? word.startTime
        : word.endTime;

    const seconds = normalizeTimestampNumber(timestamp.seconds);
    const nanos = normalizeTimestampNumber(timestamp.nanos);

    return (seconds * MILLISECONDS_IN_A_SECOND)
        + (nanos * MILLISECONDS_IN_A_SECOND) / NANOSECONDS_IN_A_SECOND;
};

export default getTranscriptionWordTimestampMs;
